import {Injectable} from '@angular/core';
import {AngularFirestore, DocumentReference} from 'angularfire2/firestore';
import {Basket} from './shopping-cart.service';
import {PaymentType} from 'src/app/screens/payment/components/payment-selection/payment-selection.component';

@Injectable()
export class PaymentService {
  constructor(private db: AngularFirestore) {
  }

  addPayment(basket: Basket, additionalData: Payment) {
    const dancers = basket.dancers.map(entry => Object.assign({}, {id: entry[0], ...entry[1]}));
    const value = Object.assign({}, basket.toJs(), {dancers: dancers}, {payment: additionalData});
    // console.log(value);
    return this.db.collection('/payments').add(
      value
    ).then((documetnReferece: DocumentReference) => {
      console.log('payment saved');
      console.dir(documetnReferece);
    });
  }
}

export interface Payment {
  type: PaymentType;

  [propName: string]: any;
}

